export const ROLES = {
  SUPER_ADMIN: "super_admin",
  VIEWER: "viewer",
  MANAGER: "manager",
  OFFICE: "office",
  OPERATOR: "operator",
  TECHNICIAN: "technician",
  VETERINARIAN: "veterinarian",
  ADMIN: "admin",
  MASTER: "master",
};

export const CUSTOMER_ROLES = [
  ROLES.VIEWER,
  ROLES.MANAGER,
  ROLES.OFFICE,
  ROLES.OPERATOR,
  ROLES.TECHNICIAN,
  ROLES.VETERINARIAN,
  ROLES.ADMIN,
];

export const ROLE_LABELS = {
  [ROLES.SUPER_ADMIN]: "Super Admin",
  [ROLES.VIEWER]: "Viewer",
  [ROLES.MANAGER]: "Manager",
  [ROLES.OFFICE]: "Office",
  [ROLES.OPERATOR]: "Operator",
  [ROLES.TECHNICIAN]: "Technician",
  [ROLES.VETERINARIAN]: "Veterinarian",
  [ROLES.ADMIN]: "Admin",
  [ROLES.MASTER]: "Master",
};

const LEGACY_ROLE_MAP = {
  user: ROLES.OPERATOR,
  viewer: ROLES.OPERATOR,
  master: ROLES.SUPER_ADMIN,
  superadmin: ROLES.SUPER_ADMIN,
};

export const normalizeRole = (role) => {
  if (!role) return ROLES.VIEWER;
  const normalized = String(role).toLowerCase();
  return LEGACY_ROLE_MAP[normalized] || normalized;
};

export const hasRole = (role, allowedRoles) => {
  return allowedRoles.includes(normalizeRole(role));
};

export const isCustomerRole = (role) => {
  return CUSTOMER_ROLES.includes(normalizeRole(role));
};

export const isRestrictedCustomerRole = (role) => {
  return [ROLES.OPERATOR].includes(normalizeRole(role));
};

export const canCreateSites = (role) => {
  return hasRole(role, [ROLES.TECHNICIAN, ROLES.ADMIN]);
};

export const canUseFirmware = (role) => {
  return hasRole(role, [ROLES.TECHNICIAN, ROLES.ADMIN]);
};

export const canManageUsers = (role) => {
  return hasRole(role, [ROLES.ADMIN]);
};

export const canManageSettings = (role) => {
  return hasRole(role, [ROLES.ADMIN]);
};

export const canManageAnimalData = (role) => {
  return hasRole(role, [ROLES.MANAGER, ROLES.ADMIN]);
};

export const canConfigureStations = (role) => {
  return hasRole(role, [ROLES.TECHNICIAN, ROLES.ADMIN]);
};

export const canDeleteSites = (role) => {
  return hasRole(role, [ROLES.ADMIN]);
};

export const canSeeOperationalBreakdown = (role) => {
  return hasRole(role, [ROLES.MANAGER, ROLES.TECHNICIAN, ROLES.ADMIN]);
};

export const creatableRolesFor = (role) => {
  if (normalizeRole(role) === ROLES.SUPER_ADMIN) {
    return [
      ROLES.ADMIN,
      ROLES.MANAGER,
      ROLES.OFFICE,
      ROLES.OPERATOR,
      ROLES.TECHNICIAN,
      ROLES.VETERINARIAN,
    ];
  }

  if (normalizeRole(role) === ROLES.ADMIN) {
    return [
      ROLES.MANAGER,
      ROLES.OFFICE,
      ROLES.OPERATOR,
      ROLES.TECHNICIAN,
      ROLES.VETERINARIAN,
    ];
  }

  return [];
};
